/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Progress,
  Radio,
  Spin,
  Tooltip,
  message,
  Input,
  Select,
  Popconfirm,
} from "antd";
import { useNavigate } from "react-router-dom";
import { camelCase } from "../../../utils";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import editButton from "../../../assests/images/penEdit.svg";
import rightArrow from "../../../assests/images/rightVector.svg";
import shipmentTruck from "../../../assests/images/shipmentTruck.svg";
import TruckProgress from "../../../assests/images/TruckProgress.svg";
import urls from "../../../api/urls";
import API from "../../../api";
import {
  getPacketListBySatus,
  getManifestVehicle,
  getManifestedList,
  updateManifestDriver,
  putManifestLock,
  updateDriverDetails,
  getPacketListClear,
  putManifestLockClear,
  clearManifestDriver,
} from "../../../actionsMethods/manifestMethods";

import lock from "../../../assests/images/lock.svg";
import readytolockicon from "../../../assests/images/readytolockicon.svg";
import tik from "../../../assests/images/tik.svg";

import Minicard from "./Minicard";
import Bigcard from "./Bigcard";
import "./style.scss";
const { GET_DRIVER_LIST, PUT_DRIVER_DETAILS } = urls;
const { Option } = Select;

const index = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading,setLoading] = useState(false);
  const [manifestListArr, setManifestListArr] = useState([]);
  const [loader, setLoader] = useState(false);
  const [radioValue, setRadioValue] = useState();
  const [hide, setHide] = useState("");
  const [loadHide, setloadHide] = useState("hide");
  const [loaded, setLoaded] = useState(false);
  const [loadToVehicle, setloadToVehicle] = useState("hide");
  const [TruckButton, setTruckButton] = useState("none");
  const [inputHide, setInputHide] = useState("");
  const [ltv, setLtv] = useState(true);
  const [editBtnStatus, setEditBtnStatus] = useState(true);
  const [filteredTruck, setFilteredTruck] = useState();
  const [driveName, setDriveName] = useState();
  const [contactNum, setContactNum] = useState();
  const [editedName, setEditedName] = useState();
  const [upperCaseName, setUpperCaseName] = useState();
  const [individual, setIndividual] = useState();
  const [driverNameList, setDriverNameList] = useState([]);
  const [filterSelectedTruck, setFilterSelectedTruck] = useState([]);
  const [form] = Form.useForm();
  const manifestFor = localStorage.getItem("manifestFor");
  const manifestIdData = JSON.parse(
    localStorage.getItem("manifestedId")
  )?.manifestId;
  const { fetching: fetching, result: getManifestedresult } = useSelector(
    (state) => state.manifestReducer.getManifestedListReducer,
    shallowEqual
  );
  const vehicleDetails = useSelector(
    (state) => state.manifestReducer.getManifestVehicleReducer,
    shallowEqual
  );

  const updateDriverResponse = useSelector(
    (state) => state.manifestReducer.updateDriverDetailsReducer,
    shallowEqual
  );

  const loadToVehcileResponse = useSelector(
    (state) => state.manifestReducer.updateManifestDriverReducer,
    shallowEqual
  );

  const manifestLockedResponce = useSelector(
    (state) => state.manifestReducer.putManifestLockReducer
  );

  const { fetching: fetching2, result: manifestLockedResult } =
    manifestLockedResponce;
  const { fetching: fetching3, result: vehicleResultData } = vehicleDetails;
  const { error: loadVehicleError } = loadToVehcileResponse;
  const { result: updateDriverResult, error: updateDriverError } =
    updateDriverResponse;

  let manifest = localStorage.getItem("manifestedId");
  let manifestId = JSON.parse(manifest);
  const getDriverList = async (filterTruckData) => {
    if (filterTruckData?.length > 0) {
      setLoading(true);
      let response = await API.Api(
        `${GET_DRIVER_LIST}${filterTruckData[0]?.vehicleClass.toUpperCase()}`
      ).getWithPremiseHeader();
      console.log(response,"response");
      if (response?.status){
        setDriverNameList(response?.response?.data);
          setLtv(false);
          setLoading(false);
      }else{
        message.error(response?.response?.data?.message);
        setLtv(true);
        setLoading(false);
      }
    }
  };
  let vehicleResult = vehicleResultData?.filter(
    (data) => data?.status == "ACTIVE"
  );
  useEffect(() => {
    let filterTruckData =  vehicleResult?.filter((val, index) => {
      return index == radioValue;
    });
    getDriverList(filterTruckData);
    setFilterSelectedTruck(
      filterTruckData
    );
  }, [radioValue]);
  useEffect(() => {
    setFilterSelectedTruck(
      vehicleResult?.filter((val, index) => {
        return index == radioValue;
      })
    );
  }, [vehicleResultData]);
  let arr =
    getManifestedresult?.shipmentScanDtos?.map((val) => val?.packetsdto) || [];

  let arr2 =
    getManifestedresult?.shipmentScanDtos.map((val) => val?.shipmentDetails) ||
    [];

  let totalPackets = arr?.filter(function (el) {
    return el != null;
  });

  let totalShipments = arr2?.filter(function (el) {
    return el != null;
  });

  let filterByweightTruck = vehicleResult?.filter(
    (data) => data?.loadCapacity >= getManifestedresult?.totalweight
  );
  useEffect(() => {
    setLoader(true);
    // dispatch(getPacketListBySatus("manifest", manifestFor));
    dispatch(getManifestVehicle());
    setLoader(false);
  }, [manifestFor]);
  useEffect(() => {
    dispatch(getManifestedList(manifestId?.manifestId));
  }, [manifestId?.manifestId]);

  useEffect(() => {
    if (loadToVehcileResponse?.result !== null) {
      message.success("Loaded to vehicle");
    } else if (loadVehicleError !== null) {
      message.error("Network error");
    }
  }, [loadToVehcileResponse]);

  useEffect(() => {
    if (updateDriverResult !== null) {
      message.success("Drive details updated");
      // dispatch(getManifestVehicle());
    } else if (updateDriverError !== null) {
      message.error("Network error");
    }
  }, [updateDriverResult]);
  useEffect(() => {
    if (manifestLockedResult !== null) {
      message.success("Manifested successfully");
      dispatch(getPacketListClear());
      dispatch(putManifestLockClear());
      dispatch(clearManifestDriver());
      navigate("/viewBooking");
    }
  }, [manifestLockedResult]);

  useEffect(() => {
    if (getManifestedresult !== null) {
      let data = [
        {
          id: "b9d39814-070c-413e-8ee2-9c6a019d409f",
          packetBarcode: 22300001276,
          service: "fast track",
          travelBy: "air",
          toPremiseId: 1,
          fromPremiseId: 43,
          status: "MANIFESTED",
          weight: 2263,
          ewayBill: null,
          packetShipments: [
            {
              id: "b12e30b5-34d2-40a7-8c8e-040d40e243bc",
              awbNo: 22110000526,
              weight: 78,
            },
            {
              id: "269bb8ff-4b7c-48b9-b685-9ee2bf3a3c5d",
              awbNo: 22110000567,
              weight: 120,
            },
            {
              id: "7ffc44bb-60c6-4577-a1d9-0b0577b7b8a3",
              awbNo: 22110000565,
              weight: 120,
            },
            {
              id: "080939bb-694a-4101-95f5-8766423b5e20",
              awbNo: 22110000528,
              weight: 350,
            },
            {
              id: "f2e876a0-348d-4f67-9db5-659353fa753f",
              awbNo: 22110000529,
              weight: 456,
            },
            {
              id: "a0ab261d-1c58-4b2e-83b7-cc320c4e9a77",
              awbNo: 22110000527,
              weight: 456,
            },
            {
              id: "9ee6dea9-d7df-4cc6-8591-ae586f11ac96",
              awbNo: 22110000525,
              weight: 683,
            },
          ],
        },
        {
          shipmentDetailsId: "749bc3f8-7a98-49f9-8aec-e8fccd33a93f",
          awbNumber: 22110000723,
          type: "dox",
          description: "Passport",
          content: "Document",
          value: 120,
          weight: 900,
          length: null,
          width: null,
          height: null,
          volumetricWeight: null,
          ewayBillNumber: null,
          service: null,
          bookingStartTime: "2023-01-06 14:42:15",
          bookingCompleteTime: "2023-01-06 14:42:28",
          destinationPincode: null,
          destinationCpId: null,
          destinationHubId: null,
          premiseId: null,
          userID: null,
          bookingStatus: "MANIFESTED",
          bookingType: null,
        },
      ];
      let arr3 = [...arr, ...arr2];

      let filtered = arr3?.filter(function (el) {
        return el != null;
      });

      setManifestListArr(filtered);
    }
  }, [getManifestedresult]);

  useEffect(() => {
    totalIndividual("awbNumber", "MANIFESTED");
  }, [manifestListArr]);

  useEffect(() => {
    form.setFieldValue("drivername", upperCaseName);
  }, [upperCaseName]);

  const onRadioChange = (e) => {
    e.preventDefault();
    setRadioValue(e.target.value);
    
  };
  const updateDriver = async (params) => {
    setTruckButton("none");
    setInputHide("");
    let driverIds = driverNameList?.filter(
      (data) => data.driverId === params?.drivername
    );
    let vehicleNumber = filterSelectedTruck[0]?.vehicleNo;
    if (driverIds) {
      let response = await API.Api(
        `${PUT_DRIVER_DETAILS}${vehicleNumber}/driver/${driverIds[0]?.driverId}`
      ).put();
      if (response?.status) {
        setDriverNameList([response?.response?.data]);
        message.success("Driver name updated successfully");
        setFilteredTruck(response?.response?.data);
        dispatch(getManifestVehicle());
      } else {
        message.error("Network error");
      }
    }
  };

  const totalIndividual = (objKey, bookingStatus) => {
    return manifestListArr.reduce((counter, obj) => {
      if (
        Object.keys(obj).includes(objKey) &&
        obj?.bookingStatus === bookingStatus
      )
        counter += 1;
      setIndividual(counter);

      return counter;
    }, 0);
  };
  const loadVehicleHandler = (e) => {
    setEditBtnStatus(false);
    e.preventDefault();
    setHide("hide");
    setloadHide("");
    setLoaded(true);
    setTruckButton("none");
    setInputHide("");
    dispatch(getPacketListBySatus("manifest", manifestFor));
    let manifestDriverPayload = {
      pickupDriverId: filterSelectedTruck[0]?.vehicleNo,
    };
    dispatch(updateManifestDriver(manifestDriverPayload, manifestIdData));
    if (filterSelectedTruck?.length > 0) {
      setFilteredTruck(filterSelectedTruck[0]);
    }
  };
  
  const lockVehicleHandler = (e) => {
    e.preventDefault();
    setloadHide("hide");
    setloadToVehicle("");
    let lockManifestPayload = {
      status: "LOCKED",
    };
    dispatch(putManifestLock(lockManifestPayload, manifestIdData));
  };

  const editHandler = () => {
    if (TruckButton === "none") {
      setTruckButton("");
      setInputHide("none");
    } else {
      setTruckButton("none");
      setInputHide("");
    }
  };
  const cancelEditHandle = () => {
    setTruckButton("none");
    setInputHide("");
  };
  const upperCase = (e) => {
    let splitStr = e.target.value.toLowerCase().split(" ");
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }

    setUpperCaseName(splitStr.join(" "));
    setDriveName(splitStr.join(" "));
    form.setFieldValue("drivername", upperCaseName);
  };
  const backFunction = () => window.history.back();
  useEffect(() => {
    // form.setFieldValue("drivername", filteredTruck?.driverName);
    // form.setFieldValue("contactNumber", filteredTruck?.contactNo);
  }, [loaded]);
  const driverSelectHandle = (e) => {
    let choosenDriver = driverNameList?.filter((data) => data?.driverId == e);
    form.setFieldValue(
      "contactNumber",
      choosenDriver.length > 0 ? choosenDriver[0]?.contactNumber : null
    );
  };
  const popConfirm = (e) => {
     let lockManifestPayload = {
      status: "LOCKED",
    };
    dispatch(putManifestLock(lockManifestPayload, manifestIdData));
  };
  const popCancel = (e) => {
    message.error("");
  };
  return (
    <div>
      <Row className="truck-container">
        <Col className="left">
          <Spin spinning={fetching || fetching2 || fetching3 || loading}>
            <Row className="header">
              <Col span={12}>
                <a
                  // href="/scan"
                  style={{ background: "none" }}
                  onClick={backFunction}
                >
                  <img src={rightArrow} />
                </a>
                <h4>Load to vehicle</h4>
              </Col>

              <Col span={5}>
                <span>Packets : </span>
                <div className="num">{totalPackets?.length}</div>
              </Col>
              <Col span={5}>
                <span>Individuals: </span>
                <div className="num">{totalShipments?.length}</div>
              </Col>
            </Row>
            <Row className="middle-heading">
              <div className="head">
                <h4>
                  <img src={shipmentTruck} /> Booked Shipment (s)
                </h4>
                <p className="total-weight">
                  Total Weight:{" "}
                  <span>{getManifestedresult?.totalweight} Kg</span>
                </p>
              </div>
            </Row>
            <Row className="outer-container">
              <Row className="main-table" gutter={32}>
                {manifestListArr &&
                  manifestListArr?.map((el, idx) => {
                    if (
                      Object.keys(el).includes("packetBarcode") &&
                      el?.status === "MANIFESTED"
                    ) {
                      return <Bigcard item={el} key={idx} />;
                    }
                    if (
                      Object.keys(el).includes("awbNumber") &&
                      el?.bookingStatus == "MANIFESTED"
                    ) {
                      return <Minicard item={el} key={idx} color={"greens"} />;
                    }
                  })}
              </Row>
            </Row>
          </Spin>
          <div className="space"></div>
          <Row className="load-box">
            {!loaded ? null : (
              <div className="loaded">
                <p>
                  <img src={tik} /> loaded
                </p>
              </div>
            )}
          </Row>
        </Col>
        <Col></Col>

        {/* //////////////////TRUCK///////////////////// */}
        <Col className="right">
          <Row className="header-two">
            <Col>
              <h4>Vehicles</h4>
            </Col>
          </Row>
          <Row className="truck-row">
            <Radio.Group onChange={onRadioChange} value={radioValue}>
              {filteredTruck ? (
                <Row className="truck-one">
                  <Form
                    layout="vertical"
                    form={form}
                    onFinish={updateDriver}
                    autoComplete="off"
                  >
                    <Col span={24} className="middle-heading-right-edit">
                      <div className="truck-one-first-heading">
                        <p>
                          HSR Hub
                          <Tooltip title="Edit">
                            <Button
                              onClick={() => editHandler()}
                              disabled={editBtnStatus}
                              className="edit-pen"
                            >
                              <img src={editButton}></img>
                            </Button>
                          </Tooltip>
                        </p>
                      </div>
                      <Row>
                        <Col span={6}>
                          <Form.Item
                            label="Driver Name"
                            colon={false}
                            style={{ display: `${inputHide}` }}
                          >
                            {filteredTruck?.driverName}
                          </Form.Item>
                          <Form.Item
                            label="Driver Name"
                            name="drivername"
                            colon={false}
                            className="input-edit"
                            style={{ display: `${TruckButton}` }}
                            onChange={(e) => setDriveName(e.target.value)}
                            rules={[
                              {
                                required: true,
                                message: "Enter driver name",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Please Select Name"
                              onChange={driverSelectHandle}
                            >
                              {driverNameList.length > 0
                                ? driverNameList?.map((driver) => (
                                    <Option
                                      key={driver?.driverId}
                                      value={driver?.driverId}
                                    >
                                      {driver?.name}
                                    </Option>
                                  ))
                                : null}
                            </Select>
                          </Form.Item>
                          <Form.Item label="Load Capacity" colon={false}>
                            {(filteredTruck?.loadCapacity / 1000).toFixed(2)}
                            Ton
                          </Form.Item>
                          <Form.Item label="Route Permit Type" colon={false}>
                            {filteredTruck?.permitType}
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item
                            label="Contact Number"
                            colon={false}
                            style={{ display: `${inputHide}` }}
                          >
                            {filteredTruck?.driverContractNumber}
                          </Form.Item>

                          <Form.Item
                            label="Contact Number"
                            name="contactNumber"
                            colon={false}
                            className="input-edit"
                            style={{ display: `${TruckButton}` }}
                            onChange={(e) => setContactNum(e.target.value)}
                          >
                            <Input
                              defaultValue={filteredTruck?.contactNo}
                              type="text"
                              maxLength={10}
                              onKeyPress={(e) => {
                                if (/[^0-9]/.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </Form.Item>

                          <Form.Item label="Truck" colon={false}>
                            {filteredTruck?.vehicleNo}
                          </Form.Item>
                        </Col>

                        <Col span={12}>
                          <Row className="truck-img">
                            <img src={TruckProgress} />
                            <Progress
                              percent={
                                getManifestedresult?.totalweight === undefined
                                  ? 0
                                  : (
                                      (parseInt(
                                        getManifestedresult?.totalweight
                                      ) /
                                        filteredTruck?.loadCapacity) *
                                      100
                                    ).toFixed(0)
                              }
                            />
                          </Row>
                        </Col>
                      </Row>

                      <Row
                        className="truck-button"
                        style={{ display: `${TruckButton}` }}
                      >
                        <Button
                          className="back-button"
                          onClick={cancelEditHandle}
                        >
                          CANCEL
                        </Button>
                        <Button className="next-button" htmlType="submit">
                          SAVE
                        </Button>
                      </Row>
                    </Col>
                  </Form>
                </Row>
              ) : (
                filterByweightTruck?.map((item, index) => {
                  return (
                    <Row className="truck-one" key={item}>
                      <Col span={24} className="middle-heading-right">
                        <div className="truck-one-first-heading">
                          <p>
                            HSR Hub
                            <Button
                              onClick={() => editHandler()}
                              disabled={editBtnStatus}
                            >
                              <img src={editButton}></img>
                            </Button>
                          </p>

                          <Radio value={index}></Radio>
                        </div>
                        <Row>
                          <Col span={6}>
                            <Form layout="vertical">
                              <Form.Item label="Driver Name" colon={false}>
                                {item?.driverName}
                              </Form.Item>

                              <Form.Item label="Load Capacity" colon={false}>
                                {(item?.loadCapacity / 1000).toFixed(2)} Ton
                              </Form.Item>
                              <Form.Item
                                label="Route Permit Type"
                                colon={false}
                              >
                                {item?.permitType}
                              </Form.Item>
                            </Form>
                          </Col>
                          <Col span={6}>
                            <Form layout="vertical">
                              <Form.Item label="Contact Number" colon={false}>
                                {item?.driverContractNumber}
                              </Form.Item>

                              <Form.Item label="Truck" colon={false}>
                                {item?.vehicleNo}
                              </Form.Item>
                            </Form>
                          </Col>
                          <Col span={12}>
                            <Row className="truck-img">
                              <img src={TruckProgress} />
                              <Progress percent={0} />
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  );
                })
              )}
            </Radio.Group>
          </Row>
          <Row className="footer-button">
            {editBtnStatus ?  <Popconfirm
              title="Skip the task"
              description="Are you sure to skip this task?"
              onConfirm={popConfirm}
              onCancel={popCancel}
              okText="Yes"
              cancelText="No"
            >
              <Button className="skip-btn">SKIP</Button>
            </Popconfirm> : null}
            <Button className={`locked ${loadToVehicle}`}>
              <img src={lock} /> vehicle locked
            </Button>
            <Button
              className={`ready-lock ${loadHide}`}
              onClick={lockVehicleHandler}
              disabled={filteredTruck?.driverName ? false : true}
            >
              <img src={readytolockicon} /> lock vehicle
            </Button>
            <Button
              className={`load-to-vehicle ${hide}`}
              disabled={ltv}
              onClick={loadVehicleHandler}
            >
              load to vehicle
            </Button>     
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default index;
